(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/views/playerlogin.js') >= 0) return;  svs.modules.push('/modules/player-login-react/views/playerlogin.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.player_login_react=_svs.player_login_react||{};
_svs.player_login_react.templates=_svs.player_login_react.templates||{};
svs.player_login_react.templates.playerlogin = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div id=\"player-login-react-view\" class=\"js-react-container login-react-vh bg-tur-200 bg-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"product") || (depth0 != null ? lookupProperty(depth0,"product") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"product","hash":{},"data":data,"loc":{"start":{"line":1,"column":89},"end":{"line":1,"column":100}}}) : helper)))
    + "\" />\n";
},"useData":true});
Handlebars.partials['svs-player_login_react-playerlogin'] = svs.player_login_react.templates.playerlogin;
})(svs, Handlebars);


 })(window);